import enGB from "./locales/en-GB.json";

type MessageCatalog = Record<string, string>;
type MessageValues = Record<string, string | number>;
type LocaleContext = {
    keys: () => string[];
    <T = MessageCatalog>(id: string): T;
};
type LocaleRequire = NodeRequire & {
    context: (
        directory: string,
        useSubdirectories: boolean,
        regExp: RegExp
    ) => LocaleContext;
};

const DEFAULT_LOCALE = "en-GB";
declare const require: LocaleRequire;

const loadCatalogs = (): Record<string, MessageCatalog> => {
    const loadedCatalogs: Record<string, MessageCatalog> = {
        [DEFAULT_LOCALE]: enGB,
    };
    const localeContext = require.context(
        "./locales",
        false,
        /\.json$/
    );

    localeContext.keys().forEach((path) => {
        const locale = path.replace("./", "").replace(".json", "");
        loadedCatalogs[locale] = localeContext<MessageCatalog>(path);
    });

    return loadedCatalogs;
};

const catalogs: Record<string, MessageCatalog> = loadCatalogs();

const interpolate = (message: string, values?: MessageValues) => {
    if (!values) {
        return message;
    }

    return message.replace(/\{(\w+)\}/g, (match, key) => {
        const value = values[key];
        return value === undefined ? match : String(value);
    });
};

export const translate = (
    locale: string,
    key: string,
    values?: MessageValues
) => {
    const catalog = catalogs[locale] || catalogs[DEFAULT_LOCALE];
    const message = catalog[key] || catalogs[DEFAULT_LOCALE][key] || key;
    return interpolate(message, values);
};
